var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"footer-container"},[_vm._v(" © 2021 ExpoNow"),_c('span',{staticClass:"bk"},[_vm._v("Blackhole Creative")])])])}]

export { render, staticRenderFns }